@if (order) {
    <mat-horizontal-stepper
        #stepper
        [ngStyle]="{'background-color': '#E8E8E8'}"
        [selectedIndex]="step"
        linear
    >
        <mat-step [completed]="step === 1" [editable]="step === 0">
            <ng-template matStepLabel>Initial Payment</ng-template>
            <card-component>
                <card-title title="Pay Initial Payment"></card-title>
                <card-content>
                    Please make an initial payment using the following details
                    <hr />
                    <table class="table table-hover">
                        <tbody>
                            <tr>
                                <th>Amount</th>
                                <td>
                                    <base-currency-component
                                        [currency]="order.currency"
                                        [value]="systemConfigService.config.payment.initial_payment_amount"
                                        [locale]="systemConfigService.config.locale"
                                        [precision]="order.currency_precision"
                                    ></base-currency-component>
                                </td>
                            </tr>
                            <tr>
                                <th>Reference</th>
                                <td>{{ order.reference }}</td>
                            </tr>
                            <tr>
                                <th>Account Details</th>
                                <td>
                                    Name: {{ systemConfigService.config.payment.account.name }}<br />
                                    Account Number: {{ systemConfigService.config.payment.account.number }}<br />
                                    Sort Code: {{ systemConfigService.config.payment.account.sort_code }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <hr />
                    <raised-button
                        [styles]="{ width: '100%' }"
                        color="primary"
                        (click)="proceedToNextStep()"
                    >Next</raised-button>
                </card-content>
            </card-component>
        </mat-step>
        <mat-step [completed]="step === 2" [editable]="step === 1">
            <ng-template matStepLabel>Setup Standing Order</ng-template>
            <card-component>
                <card-title title="Setup Standing Order"></card-title>
                <card-content>
                    Please setup a standing order for the remaining balance
                    <hr />
                    <table class="table table-hover">
                        <tbody>
                        <tr>
                            <th>Total Amount</th>
                            <td>
                                <base-currency-component
                                    [currency]="order.currency"
                                    [value]="order.total"
                                    [locale]="systemConfigService.config.locale"
                                    [precision]="order.currency_precision"
                                ></base-currency-component>
                            </td>
                        </tr>
                        <tr>
                            <th>Initial Amount</th>
                            <td>
                                <text-input
                                    [(value)]="initialPaymentAmount"
                                    (valueChange)="handlePaymentAmounts($event)"
                                    [prefix]="systemConfigService.config.currency.symbol"
                                ></text-input>
                            </td>
                        </tr>
                        <tr>
                            <th>Amount Remaining</th>
                            <td>
                                <base-currency-component
                                    [currency]="order.currency"
                                    [value]="remaining"
                                    [locale]="systemConfigService.config.locale"
                                    [precision]="order.currency_precision"
                                ></base-currency-component>
                            </td>
                        </tr>
                        <tr>
                            <th>Reference</th>
                            <td>{{ order.reference }}</td>
                        </tr>
                        <tr>
                            <th>Account Details</th>
                            <td>
                                Name: {{ systemConfigService.config.payment.account.name }}<br />
                                Account Number: {{ systemConfigService.config.payment.account.number }}<br />
                                Sort Code: {{ systemConfigService.config.payment.account.sort_code }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <hr />
                    <raised-button
                        [styles]="{ width: '100%' }"
                        color="primary"
                        (click)="proceedToNextStep()"
                    >Next</raised-button>
                </card-content>
            </card-component>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Confirmation</ng-template>
            <card-component>
                <card-title title="Confirmation"></card-title>
                <card-content>
                    <h1 [ngStyle]="{ 'text-align': 'center', 'font-size': '100px', color: '#28a745' }">
                        <i class="fa-solid fa-circle-check"></i>
                    </h1>
                    <div>
                        <raised-button color="primary" (click)="viewOrders()" [styles]="{ width: '100%' }">View Orders</raised-button>
                    </div>
                </card-content>
            </card-component>
        </mat-step>
    </mat-horizontal-stepper>
}
